/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StopwatchIcon = /*#__PURE__*/ createSvgIcon(
  'StopwatchIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M8.25 3a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535A.72.72 0 018.25 1.5h3.5c.213 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535A.72.72 0 0111.75 3h-3.5zm1.746 9c.21 0 .39-.072.535-.216a.72.72 0 00.219-.534v-3.5a.728.728 0 00-.214-.534.72.72 0 00-.532-.216.734.734 0 00-.535.216.72.72 0 00-.219.534v3.5c0 .213.071.39.214.534a.72.72 0 00.532.216zM10 18a6.76 6.76 0 01-2.728-.552 7.12 7.12 0 01-2.218-1.502 7.12 7.12 0 01-1.502-2.219A6.76 6.76 0 013 11c0-.972.184-1.881.552-2.727a7.121 7.121 0 011.502-2.219 7.121 7.121 0 012.218-1.502A6.738 6.738 0 019.992 4c.81 0 1.586.135 2.33.406s1.436.65 2.075 1.136l.568-.569a.671.671 0 01.515-.213A.758.758 0 0116 5c.153.153.23.326.23.52a.718.718 0 01-.23.522l-.542.562a7.49 7.49 0 011.136 2.059c.27.747.406 1.527.406 2.34 0 .97-.184 1.878-.552 2.724a7.12 7.12 0 01-1.502 2.219 7.12 7.12 0 01-2.219 1.502A6.76 6.76 0 0110 18zm0-1.5c1.528 0 2.826-.535 3.896-1.604 1.07-1.07 1.604-2.368 1.604-3.896s-.535-2.826-1.604-3.896C12.826 6.034 11.528 5.5 10 5.5s-2.826.535-3.896 1.604C5.034 8.174 4.5 9.472 4.5 11s.535 2.826 1.604 3.896C7.174 15.966 8.472 16.5 10 16.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default StopwatchIcon;
